
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { UsuarioInfo } from "@/store/modules/UsuarioModule";
interface Buscador {
  estado?: number;
  factura?: number;
  empresaId?: number;
  fechaInicio?: Date;
  fechaTermino?: Date;
  proveedorId: number;
}
export interface UsuarioDetails {
  contactoNombre: string;
  contactoApellido: string;
}
export interface SolicitudDetails {
  usuarioAprobador: string;
}

export default defineComponent({
  name: "kt-subscription-list",
  components: {
    DataTable,
    Column,
  },
  data() {
    return {
      store: useStore(),
      router: useRouter(),
    };
  },
  methods: {
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },
  setup() {
    const router = useRouter();
    const submitButton1 = ref<HTMLElement | null>(null);
    const store = useStore();
    const approveSolicitudesDialog = ref(false);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Mis Solicitudes de Cuenta", [
        "Página",
        "Dashboard",
      ]);
      buscarSolicitudes();
    });
    const buscador = ref<Buscador>({
      proveedorId: store.getters.currentUser.id,
    });
    const buscadorValidator = Yup.object().shape({});
    const editSolicitud = (solicitud) => {
      router.push({
        name: "app-subscription-details",
        params: { id: solicitud.solicitudId },
      });
    };
    const confirmApproveSelected = () => {
      approveSolicitudesDialog.value = true;
    };
    const approveSelectedSolicitudes = () => {
      if (selectedSolicitudes.value != undefined) {
        selectedSolicitudes.value.forEach(
          (element) =>
            (element.usuarioAprobador = `${currentUser.value.contactoNombre} ${currentUser.value.contactoApellido}`)
        );
        store
          .dispatch(Actions.UPD_SOLICITUDES, selectedSolicitudes.value)
          .then(() => {
            approveSolicitudesDialog.value = false;
            selectedSolicitudes.value = [];
            Swal.fire({
              text: "Solicitud Aprobada. Se ha creado el Usuario y enviada las credenciales al correo electrónico",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              buscarSolicitudes();
            });
          })
          .catch(() => {
            const [error] = Object.keys(store.getters.getEmpresaErrors);
          });
      }
    };
    const buscarSolicitudes = () => {
      store
        .dispatch(Actions.GET_SOLICITUDES)
        .then(() => {
          loading.value = false;
          // submitButton1.value?.removeAttribute("data-kt-indicator");
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getSolicitudErrors);
        });
    };
    const currentUser = computed<UsuarioDetails>(() => {
      return store.getters.currentUser;
    });
    const filters1 = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const search = ref(null);
    const selectedSolicitudes = ref<Array<SolicitudDetails>>();
    const loading = ref(true);
    return {
      filters1,
      buscador,
      selectedSolicitudes,
      loading,
      buscadorValidator,
      buscarSolicitudes,
      submitButton1,
      editSolicitud,
      approveSolicitudesDialog,
      confirmApproveSelected,
      approveSelectedSolicitudes,
      currentUser,
    };
  },
});
